import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import ProductFilterCriteria from './ProductFilterCriteria'
import ProductListImpl from './ProductListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './ProductAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setProductDashboardProductList } from '../../store/slice/PharmaSlice';

export default function ProductListView({setShowEdit,setProductId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.productDashboard);   

    const [filteredProductList, setFilteredProductList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { productDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (productDashboard.productList.length>-1){
        setFilteredProductList(productDashboard.productList);
        transformToCardFormat(productDashboard.productList, setCardList);
      }
    },[productDashboard.productList])

    useEffect(()=>{
          transformToCardFormat(filteredProductList, setCardList);
      },[filteredProductList])

    useEffect(()=>{
        if (filterCriteria.partyname==='' && filterCriteria.title==='' && filterCriteria.statusid==='' && filterCriteria.formid==='' && filterCriteria.packagingtypeid==='' && filterCriteria.amount==='' && filterCriteria.orderid==='' && filterCriteria.shapeid==='' && filterCriteria.statusname==='' && filterCriteria.rmstatus==='' && filterCriteria.packagingsize1id==='' && filterCriteria.setid==='' && filterCriteria.brandname==='' && filterCriteria.repeatorder==='' && filterCriteria.designapprovaldate==='' && filterCriteria.qadesignapprovaldate==='' && filterCriteria.qacompapprovaldate==='' && filterCriteria.batchnumber==='' && filterCriteria.pmorderid==='' && filterCriteria.rmorderid==='' && filterCriteria.gstid==='' && filterCriteria.gstname==='' && filterCriteria.inventorycharges==='' && filterCriteria.cylindercharges==='' && filterCriteria.repeatproduct==='' && filterCriteria.repeatproductid==='' && filterCriteria.advance==='' && filterCriteria.total==='' && filterCriteria.totalwithgst==='' && filterCriteria.assetname==='' && filterCriteria.assetpath==='' && filterCriteria.assetid==='' && filterCriteria.pmreceivedon==='' && filterCriteria.qaassetid==='' && filterCriteria.qaassetname==='' && filterCriteria.qaassetpath==='' && filterCriteria.packagingtext==='' && filterCriteria.liquidcolor==='' && filterCriteria.manufdate==='' && filterCriteria.overallstatusid==='' && filterCriteria.approvaldate==='' && filterCriteria.submissiondate==='' && filterCriteria.deliverydate==='' && filterCriteria.cancelleddate==='' && filterCriteria.mrptext==='' && filterCriteria.reasondate==='' && filterCriteria.reason==='' && filterCriteria.monthtagid==='' && filterCriteria.prestatusid==='' && filterCriteria.biltyid==='' && filterCriteria.executiveid==='' ){
            setFilteredProductList(productDashboard.productList);
            transformToCardFormat(productDashboard.productList, setCardList);

        } else {
            setFilteredProductList(
                productDashboard.productList
                    .filter(product=> product.partyname.toString().toUpperCase().includes(filterCriteria.partyname.toString().toUpperCase()))
.filter(product=> product.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(product=> product.statusid.toString().toUpperCase().includes(filterCriteria.statusid.toString().toUpperCase()))
.filter(product=> product.orderid.toString().toUpperCase().includes(filterCriteria.orderid.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(productDashboard.filteredProductList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <ProductListImpl
                    setShowEdit={setShowEdit}
                    setProductId = {setProductId}
                    tableList={filteredProductList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}